import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import anime from "animejs";
import {
    rellaxinit
} from "./paralax"
import {
    accinit
} from './acc';
import {
    changecolorinit,
    changetopsvg
} from './change';
import {
    splash
} from './splash';
import {
    imgmoverinit
} from './imgmover';
import {
    showWeather
} from './weather';
import {
    showTime
} from './time';
import {
    sminit
} from './scrollmagic';
import {
    spanwrapinit
} from './SpanWrap';
import {
    svgmoverinit
} from './svgmover';

//header・body書き換え
const replaceHead = function (data) {
    const head = document.head;
    const newPageRawHead = data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
    const newPageHead = document.createElement('head');
    newPageHead.innerHTML = newPageRawHead;

    const removeHeadTags = [
        "meta[name='keywords']", "meta[name='description']", "meta[property^='og']", "meta[name^='twitter']", "meta[itemprop]", "link[itemprop]", "link[rel='prev']", "link[rel='next']", "link[rel='canonical']"
    ].join(',');

    const headTags = head.querySelectorAll(removeHeadTags)

    for (let i = 0; i < headTags.length; i++) {
        head.removeChild(headTags[i]);
    }

    const newHeadTags = newPageHead.querySelectorAll(removeHeadTags)

    for (let i = 0; i < newHeadTags.length; i++) {
        head.appendChild(newHeadTags[i]);
    }

    //bodyクラス変更
    let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
        match = regexp.exec(data.next.html);
    if (!match || !match[1]) {
        // If no body class, remove it
        document.body.setAttribute("class", "");
    } else {
        // Set the new body class
        document.body.setAttribute("class", match[1]);
    }
}

// ページ遷移時に実行する内容

function everyMove() {
    spanwrapinit()
    rellaxinit()
    accinit()
    changecolorinit()
    changetopsvg()
    splash()
    imgmoverinit()
    showWeather()
    showTime()
    sminit()
    svgmoverinit()
    window.globalLocoUpdate(true)
}

everyMove()

barba.hooks.before((data) => {})

barba.hooks.enter((data) => {
    replaceHead(data);
    document.body.classList.remove("loading")
    window.globalLocoUpdate(true)
})

barba.hooks.after((data) => {
    everyMove()
})

barba.use(barbaPrefetch);

let headerLogoLines = [document.querySelector(".header__innerLogoLine"), document.querySelector(".spheaderlogoLine")]

barba.init({
    transitions: [{
        name: 'page-transition',
        sync: true,
        leave: function (data) {
            const done = this.async();
            data.current.container.classList.add("js-barba__leave");
            anime.timeline().add({
                targets: data.current.container,
                opacity: [1, 0],
                easing: "cubicBezier(.17,.67,.48,.92)",
                duration: 300,
                // delay: 200,
                complete: function () {
                    window.scrollTo(0, 0)
                    done();
                }
            }).add({
                targets: headerLogoLines,
                transformOrigin: "center left 0",
                translateX: ["-50%", "-50%"],
                scaleX: ["0%", "100%"],
                easing: "cubicBezier(.17,.67,.48,.92)",
                duration: 1100,
            }, "0").add({
                targets: headerLogoLines,
                transformOrigin: "center right 0",
                translateX: ["-50%", "-50%"],
                scaleX: ["100%", "0%"],
                easing: "cubicBezier(.17,.67,.48,.92)",
                duration: 400,
            }, )
        },
        enter: function (data) {
            const done = this.async();
            data.next.container.classList.add("js-barba__enter");
            anime.timeline().add({
                targets: data.next.container,
                opacity: [0, 1],
                easing: "cubicBezier(.17,.67,.48,.92)",
                duration: 900,
                delay: 300,
                complete: function () {
                    done();
                    data.next.container.classList.remove("js-barba__enter");
                }
            })
        }
    }],
})